"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureApollo = exports.getSiteDegradedFromNetworkError = exports.getErrorCodeREFACTORED = exports.getRetryAfter = exports.getStatusCode = exports.getRequestId = exports.getFirstError = exports.getErrorResponseData = exports.getErrorPayload = exports.getErrorMessage = exports.getErrorCode = exports.DEGRADED_ERROR_CODE = void 0;
var component_experience_1 = require("@doordash/component-experience");
var client_1 = require("@apollo/client");
var context_1 = require("@apollo/client/link/context");
var error_1 = require("@apollo/client/link/error");
var get = require("lodash.get");
var lib_i18n_1 = require("@doordash/lib-i18n");
var DEFAULT_ERROR_CODE = 400;
exports.DEGRADED_ERROR_CODE = 'SERVICE_UNAVAILABLE';
var onErrorLink = error_1.onError(function (_a) {
    var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError;
    if (graphQLErrors) {
        graphQLErrors.map(function (_a) {
            var message = _a.message, locations = _a.locations, path = _a.path;
            // tslint:disable-next-line:no-console
            console.error("[GraphQL error]:\n          Message: " + JSON.stringify(message) + ",\n          Location: " + JSON.stringify(locations) + ",\n          Path: " + path);
        });
    }
    if (networkError) {
        // tslint:disable-next-line:no-console
        console.error("[Network error]: " + networkError);
    }
});
var logOperationLink = function (graphqlUrl) {
    return context_1.setContext(function (_, context) {
        if (!context.logOperationName) {
            return context;
        }
        return __assign(__assign({}, context), { uri: graphqlUrl + "?operation=" + context.logOperationName });
    });
};
var httpLink = function (graphqlUrl, language, experience) {
    return new client_1.HttpLink({
        uri: graphqlUrl,
        credentials: 'include',
        headers: {
            'Accept-Language': language,
            'X-Experience-Id': experience,
        },
        fetchOptions: {
            credentials: 'include',
        },
    });
};
exports.getErrorCode = function (error) {
    return get(error, 'graphQLErrors[0].extensions.code') || '';
};
exports.getErrorMessage = function (error) {
    return get(error, 'graphQLErrors[0].message') || '';
};
exports.getErrorPayload = function (error) {
    return get(error, 'graphQLErrors[0].extensions.exception') || {};
};
exports.getErrorResponseData = function (error) {
    return get(error, 'graphQLErrors[0].extensions.exception.responseData') || {};
};
exports.getFirstError = function (error) {
    if (error === undefined) {
        return undefined;
    }
    if (error instanceof Array) {
        return error[0];
    }
    if (error.graphQLErrors instanceof Array) {
        return error.graphQLErrors[0];
    }
    return undefined;
};
exports.getRequestId = function (error) {
    var firstError = exports.getFirstError(error);
    if (firstError !== undefined && firstError.extensions !== undefined) {
        var hasCorrelationID = !!firstError.extensions.correlationId;
        return hasCorrelationID ? firstError.extensions.correlationId : undefined;
    }
    return undefined;
};
exports.getStatusCode = function (error) {
    var firstError = exports.getFirstError(error);
    if (firstError !== undefined && firstError.extensions !== undefined) {
        var hasStatus = !!firstError.extensions.status;
        return hasStatus ? firstError.extensions.status : DEFAULT_ERROR_CODE;
    }
    return DEFAULT_ERROR_CODE;
};
exports.getRetryAfter = function (error) {
    var firstError = exports.getFirstError(error);
    if (firstError !== undefined && firstError.extensions !== undefined) {
        var hasRetryAfter = !!firstError.extensions.retryAfter;
        return hasRetryAfter ? firstError.extensions.retryAfter : undefined;
    }
    return undefined;
};
exports.getErrorCodeREFACTORED = function (error) {
    var firstError = exports.getFirstError(error);
    if (firstError !== undefined && firstError.extensions !== undefined) {
        var hasErrorCode = !!firstError.extensions.code;
        return hasErrorCode ? firstError.extensions.code : '';
    }
    return '';
};
exports.getSiteDegradedFromNetworkError = function (error) {
    if (!error) {
        return undefined;
    }
    if ('result' in error && error.result.errors) {
        var graphqlErrors = error.result.errors;
        var statusCode = exports.getStatusCode(graphqlErrors);
        var retryAfter = exports.getRetryAfter(graphqlErrors);
        var errorCode = exports.getErrorCodeREFACTORED(graphqlErrors);
        var correlationId = exports.getRequestId(graphqlErrors);
        if (errorCode === exports.DEGRADED_ERROR_CODE) {
            return {
                errorCode: errorCode,
                correlationId: correlationId,
                statusCode: statusCode,
                retryAfter: retryAfter,
            };
        }
    }
    if ('statusCode' in error &&
        (error.statusCode === 429 || error.statusCode === 503)) {
        var correlationId = error.response.headers.get('x-correlation-id') ||
            error.response.headers.get('x-request-id') ||
            undefined;
        return {
            correlationId: correlationId,
            errorCode: exports.DEGRADED_ERROR_CODE,
            statusCode: error.statusCode,
            retryAfter: Number(error.response.headers.get('retry-after')),
        };
    }
    return undefined;
};
exports.configureApollo = function (_a) {
    var graphqlUrl = _a.graphqlUrl, _b = _a.language, language = _b === void 0 ? lib_i18n_1.SupportedLanguages.EN : _b, _c = _a.experience, experience = _c === void 0 ? component_experience_1.Experience.DoorDash : _c, appInfo = _a.appInfo, _d = _a.middlewares, middlewares = _d === void 0 ? [] : _d;
    return new client_1.ApolloClient({
        // i.e. @doordash/app-consumer-production
        name: appInfo.appName + "-" + appInfo.appEnv,
        // i.e. 0.253.0-production
        version: appInfo.appVersion + "-" + appInfo.appEnv,
        link: client_1.ApolloLink.from(__spread(middlewares, [
            onErrorLink,
            logOperationLink(graphqlUrl),
            httpLink(graphqlUrl, language, component_experience_1.parseExperience(experience)),
        ])),
        cache: new client_1.InMemoryCache(),
    });
};
